var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPatterSolucao2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 784,
    viewBox: "0 0 1920 784",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.0703125 782C92.1004 777.225 176.224 737.947 252.397 619.039C347.614 470.404 543.818 -15.7945 990.084 71.5065C1221.39 133.736 1069.91 516.52 1289.68 653.511C1344.98 687.984 1518.09 811.339 1802.79 733.201C2006.69 677.239 1960.52 424.291 1933.11 365.643",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 3.62737,
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.0703125 752.452C92.1004 747.677 176.224 708.399 252.397 589.491C347.614 440.856 543.818 -45.3425 990.084 41.9584C1221.39 104.188 1069.91 486.972 1289.68 623.963C1344.98 658.436 1518.09 781.791 1802.79 703.653C2006.69 647.691 1960.52 394.743 1933.11 336.095",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 3.62737,
    strokeDasharray: "7.25 7.25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.0703125 722.904C92.1004 718.129 176.224 678.851 252.397 559.943C347.614 411.308 543.818 -74.8906 990.084 12.4103C1221.39 74.6398 1069.91 457.424 1289.68 594.415C1344.98 628.888 1518.09 752.243 1802.79 674.105C2006.69 618.143 1960.52 365.195 1933.11 306.546",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 3.62737,
    strokeLinejoin: "bevel"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatterSolucao2);
export default __webpack_public_path__ + "static/media/patterSolucao2.b1c044a3ecb92c257986c6347966b8c6.svg";
export { ForwardRef as ReactComponent };